export var EditorColoringType;
(function (EditorColoringType) {
    EditorColoringType["Group"] = "group";
    EditorColoringType["Element"] = "element";
    EditorColoringType["Auto"] = "auto";
})(EditorColoringType || (EditorColoringType = {}));
